import Button from './Button';

export default function UnsavedChangesBar({ dirty, saving, onSave, onDiscard }) {
  if (!dirty) return null;

  return (
    <div className="sticky bottom-0 left-0 right-0 z-10 flex items-center justify-between rounded-md border border-primary-light bg-primary-50 px-4 py-3 shadow-sm">
      <span className="text-sm text-primary-dark font-medium">You have unsaved changes</span>
      <div className="flex gap-3">
        <Button variant="ghost" onClick={onDiscard} disabled={saving}>
          Discard
        </Button>
        <Button onClick={onSave} loading={saving}>
          Save
        </Button>
      </div>
    </div>
  );
}
